import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { HotelSearchComponent } from '../../../components/hotel-search/hotel-search.component';
import { HotelDescriptionComponent } from '../hotel-description/hotel-description.component';

@Component({
  selector: 'app-hotel-route-decision',
  standalone: true,
  imports: [
    HotelSearchComponent,
    HotelDescriptionComponent,
  ],
  templateUrl: './hotel-route-decision.component.html',
  styleUrl: './hotel-route-decision.component.scss',
})
export class HotelRouteDecisionComponent {

  type: string = '';
  routeData: any = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {


    const decision =
      this.route.snapshot.data['decision'];

    this.handleDecision(decision);

    this.route.data.subscribe(({ decision }) => {
      this.handleDecision(decision);
    });
  }


  private handleDecision(decision: any): void {

    this.type =
      decision?.type || '';

    this.routeData =
      decision?.data || null;

    if (decision?.type === '404') {

      this.router.navigateByUrl(
        '/404',
        {
          replaceUrl: true,
        }
      );

      return;
    }


    if (decision?.type === 'hotel') {
      return;
    }


    if (decision?.type === 'destination') {

      return;
    }

    if (!decision || !decision.type) {

      this.router.navigateByUrl(
        '/404',
        {
          replaceUrl: true,
        }
      );

      return;
    }
  }
}